import { createAsyncThunk } from '@reduxjs/toolkit';

import { getClassificationSubgroupListService } from 'services/classification_subgroup.service';

export const getClassificationSubgroupList = createAsyncThunk(
  'classificationSubgroup/list',
  async (_, thunkApi) => {
    try {
      const response = await getClassificationSubgroupListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
